import React from 'react';
import FlatButton from 'material-ui/FlatButton';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import PageAncestor from 'core/common/page/pageAncestor';
import Axios from 'core/common/config/axios-config';
import Grid from 'core/grid/domain/grid';
import GridConfig from 'core/grid/domain/gridConfig';
import gridService from 'core/grid/gridService';
import GridAdminComp from 'core/grid/component/gridAdminComp';
import Toolmenu from 'core/components/toolmenu/toolmenu';
import {observer} from "mobx-react";
import {CONFIGLEVEL, PageProps} from "core/metamodel/metaConstant";
import {observable, action, ObservableMap} from "mobx";
import mdEntityService from "core/metamodel/mdEntityService";
import uiService from "core/common/service/uiService";
import {removeItemFromLocalStorage} from "core/common/utils/storage";
import {loc} from "core/common/config/locales";


@observer
export default class GridAdminView extends PageAncestor<PageProps, undefined> {

  static title = loc.i18n`Manage Grid`;
  static icon = 'wrench';



  gridAdminCompRef: GridAdminComp;

  @observable gridObject: Grid;


  prepareGridConfig(grid: Grid, gridId: number|string, copiedGridId: number) {
    if (gridId === 'new') {
      return GridConfig.newInstance(grid.$gridLocationRef);
    } else if (gridId === 'copy') {
      let copiedGridConfig = grid.getGridConfig(copiedGridId).clone();
      copiedGridConfig.cleanOnCopy();
      copiedGridConfig.configLevel = mdEntityService.getEntity("CONFIGLEVEL").getLovItem(CONFIGLEVEL.USER) as any ;
      copiedGridConfig.tenant = null;
      copiedGridConfig.tenantGroup = null;

      copiedGridConfig.defaultGrid = undefined;
      return copiedGridConfig;
    } else {
      return grid.getGridConfig(gridId as number);
    }
  }


  componentDidMount() {
    let gridConfig;
    let {params, query} = this.props;

    let mdEntityPromise = mdEntityService.fetchEntities([{entity: "CONFIGLEVEL", lov: true}, {entity: "Tenant", lov: true}, {entity: "TenantGroup", lov: true}, {entity: "GRIDROWCSS", lov: true}]);
    let gridLocationPromise = gridService.fetchGrids(params.gridLocation);

    Promise.all([mdEntityPromise, gridLocationPromise])
      .then(([entities, gridLocationMap]) => {
        this.gridObject = gridService.getGrid(params.gridLocation);
        if (!this.gridObject) this.gridObject = new Grid(gridLocationMap.get(params.gridLocation));
        if (params.gridId) {
          gridConfig = this.prepareGridConfig(this.gridObject, params.gridId, query.copyId);
          gridService.gridConfig = gridConfig;
          return (gridConfig) ? gridService.fetchConditionLovs(gridConfig.conditions) : Promise.resolve(null)
        } else {
          return Promise.resolve(null);
        }
      })
      .then(entityMap => (gridConfig && gridConfig.conditions) ? gridConfig.conditions.forEach(cond => this.gridAdminCompRef.setupConditionField(cond, true) ) : null);
  }


  componentWillReceiveProps(nextProps: PageProps) {
    console.debug("GridAdminView componentWillReceiveProps");
    if (this.props.params.gridId !== nextProps.params.gridId) {
      gridService.gridConfig = this.prepareGridConfig(this.gridObject, nextProps.params.gridId, nextProps.query.copyId);;
    }
  }

  componentWillUnmount() {
    gridService.gridConfig = null;
    this.gridObject = null;
  }


  /* ****************   EVENT HENDLERS ************************************************************ */

  @action onChangeGridConfig = (evt, key, gridId) => {
    console.log('onChangeGridConfig gridId = %s', gridId);

    let gridConfig = this.gridObject.getGridConfig(gridId);

    gridService.fetchConditionLovs(gridConfig.conditions)
      .then((entityMap) => {
        gridService.gridConfig = gridConfig;
        this.context.router.replaceWith("gridAdmin", {gridLocation: this.gridObject.gridLocation, gridId: gridConfig.gridId});
      });

  };


  @action onClickSave = (evt) => {
    console.log('onClickSave %O', gridService.gridConfig);
    uiService.showToolbarActionFlag();
    this.gridAdminCompRef.save()
      .then((newGridConfig) => {
        if (newGridConfig) {
          this.context.router.replaceWith("gridAdmin", {gridLocation: this.gridObject.gridLocation, gridId: newGridConfig.gridId});
        }
        uiService.hideToolbarActionFlag();
      });
  };



  onClickAdd = (evt) => {
    console.log('onClickAdd');
    this.context.router.transitionTo("gridAdmin", {gridLocation: this.gridObject.gridLocation, gridId: 'new'});
  };

  onClickCopy = (evt) => {
    console.log('onClickCopy');
    this.context.router.transitionTo("gridAdmin", {gridLocation: this.gridObject.gridLocation, gridId: 'copy'}, {copyId: gridService.gridConfig.gridId});
  };


  @action onClickDelete = (evt) => {

    console.log('onClickDelete ' + gridService.gridConfig.gridId);


    Axios.delete('/core/grid-config/' + gridService.gridConfig.gridId)
      .then(response => {
        this.gridObject.deleteGridConfig(gridService.gridConfig.gridId);
        removeItemFromLocalStorage("GridLocation", loc.lang, gridService.gridConfig.gridLocation);
        this.context.router.transitionTo("gridAdmin", {gridLocation: this.gridObject.gridLocation});
        gridService.gridConfig = null;
      });
  };

  onClickBack = () => {
    console.log('onClickBack');
    let ok = this.context.router.goBack();
    if (!ok) {
      this.context.router.transitionTo(this.props.params.gridLocation);
    }
  };

  gridAdminCompRefHandler = (comp) => this.gridAdminCompRef = comp;

  /* ****************   REACT METHODS ************************************************************ */

  render() {

    if (!this.gridObject) return <noscript/>

    let toolMenu = this._createToolMenu(gridService.gridConfig);


    const gridConfigItems = this.gridObject.gridConfigs.map((gc, i) => <MenuItem value={gc.gridId} key={i}
                                                                      primaryText={gc.label}/>);
    console.debug('gridAdminView render gridConfig : %O', gridService.gridConfig);

    return (
      <main className="main-content container">
        {toolMenu}

        <h4 className="zauzoo" style={{marginTop: 20}}>{loc.i18n`Grid Management`}</h4>

        <SelectField
          value={ (gridService.gridConfig) ? gridService.gridConfig.gridId : null}
          style={{fontSize: 14, marginLeft: 10}}
          menuItemStyle={{fontSize: 14}}
          onChange={this.onChangeGridConfig}
          disabled={gridService.gridConfig && gridService.gridConfig.$new}
          hintText={loc.i18n`Choose Grid`} autoComplete="off">
          {gridConfigItems}
        </SelectField>

        { (gridService.gridConfig) ? <GridAdminComp ref={this.gridAdminCompRefHandler} gridLocation={this.gridObject.$gridLocationRef} grid={this.gridObject} gridConfig={gridService.gridConfig} entities={mdEntityService.entityMap}/> : null }



      </main>

    );
  }

  /* ****************   NORMAL METHODS ************************************************************ */


  _createToolMenu(gridConfig: GridConfig) {

    let {disabled} = gridService.computeConfigLevels(this.gridObject.$gridLocationRef, gridConfig);

    return (
      <Toolmenu backAction={this.onClickBack} backDisabled={false}>
        { (gridConfig && !disabled) ? (
          <FlatButton onClick={this.onClickSave} label={loc.i18n`Save grid`}/>
        ) : <noscript/> }
        <FlatButton onClick={this.onClickAdd} label={loc.i18n`Create new grid`}/>
        { (gridConfig) ? (
          <FlatButton onClick={this.onClickCopy} label={loc.i18n`Copy grid`}/>
        ) : <noscript/> }
        { (gridConfig && !disabled) ? (
          <FlatButton onClick={this.onClickDelete} label={loc.i18n`Delete grid`}/>
        ) : <noscript/> }
      </Toolmenu>
    );
  }


}




// WEBPACK FOOTER //
// ./src/core/grid/component/gridAdminView.tsx